import { atomWithStorage } from 'jotai/utils';

import { UserTheme } from '@gitbook/app-database';
import { USER_THEME_STORAGE_KEY } from '@gitbook/react-uikit';

/**
 * The user's theme preference for the app.
 *
 * The Recoil-era value (`@recoil/userThemeAtom`) is moved onto this key by
 * `migrateLegacyPersistedState`, before anything reading it is rendered.
 */
export const userThemeAtom = atomWithStorage(USER_THEME_STORAGE_KEY, UserTheme.Default, undefined, {
    getOnInit: true,
});
